import * as React from 'react';
import { ReactNode } from 'react';

import { Body, StyledContainer } from './FiltersList.styles';

interface FilterListProps {
  children: ReactNode;
}

const FiltersList = ({ children }: FilterListProps) => {
  return (
    <StyledContainer>
      <Body>{children}</Body>
    </StyledContainer>
  );
};

export default FiltersList;
